var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('PageToolbar',{attrs:{"title":_vm.$tc('global.cliente', 2),"icon":"mdi-clipboard-account-outline","dark":""}}),_c('ListaClientes')],1)}
var staticRenderFns = []

export { render, staticRenderFns }